export interface ServerRuntimeConfig {
    [hostname: string]: string;
}

const CONFIG_URL = '/server-config.json';

/**
 * Resolves the LCA backend API URL to use, based on the hostname the app is
 * currently served from. This allows the same build artifact to be deployed
 * to every environment (dev/sandbox, staging, prod, ...) while still calling
 * the correct backend, since the mapping is looked up at runtime rather than
 * baked into the bundle at build time.
 *
 * Resolution order:
 * 1. An exact match for `window.location.hostname` in /server-config.json
 * 2. The "default" entry in /server-config.json
 */
export async function loadLcaServerUrl(): Promise<string | undefined> {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    let config: ServerRuntimeConfig = {};
    try {
        const response = await fetch(CONFIG_URL, { cache: 'no-store' });
        if (response.ok) {
            config = await response.json();
        } else {
            console.warn(`Could not load ${CONFIG_URL}: ${response.status}`);
        }
    } catch (error) {
        console.warn(`Could not load ${CONFIG_URL}`, error);
    }

    return config[hostname] || config.default;
}
